// Module
var code = "<div class=\"col-12 col-md-12 faq-items category-faqs__inner\"> <category-faq-item class=\"category-faq-item\" item=\"::item\" ng-repeat=\"item in $ctrl.faqItems\"/> </div> ";
// Exports
module.exports = code;